import React from "react";

import { getEmployeeForm, getFamilyInfo } from "EmployeeApplication/api";
import { useSelector } from "react-redux";

import EmployeeMultiplePlans from "./EmployeeMultiplePlans";
import EmployeeSinglePlan from "./EmployeeSinglePlan";

import type { Plan, ContributionFormula, FamilyQuote } from "Utils/types";

type Props = {
  plans: Array<Plan>;
  prices: Array<FamilyQuote>;
  contributions: ContributionFormula;
};

const EmployeeCoverage = ({ plans, prices, contributions, backLink, onClickBack }: Props) => {
  const employeeForm = useSelector(getEmployeeForm);
  const familyInfo = useSelector(getFamilyInfo);

  if (plans.length > 1) {
    return (
      <EmployeeMultiplePlans
        plans={plans as Array<any>}
        prices={prices}
        employeeForm={employeeForm}
        familyInfo={familyInfo}
        contributions={contributions}
        backLink={backLink}
        onClickBack={onClickBack}
      />
    );
  }
  return (
    <EmployeeSinglePlan
      plan={plans[0]}
      prices={prices[0]}
      employeeForm={employeeForm}
      familyInfo={familyInfo}
      contributions={contributions}
      backLink={backLink}
      onClickBack={onClickBack}
    />
  );
};

export default EmployeeCoverage;
